<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
    </ion-buttons>
    <ion-title>{{ 'title.chat.result.type.0' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-icon name="close-outline" class="cursor-pointer text-4xl" (click)="closeDialog()"></ion-icon>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<div class="overflow-hidden w-full h-full flex-auto flex flex-col bg-white">
  <ion-content>
    <div class="flex flex-col flex-auto overflow-y-auto">
      <div class="px-5 mt-5 flex items-center text-gray-400">
        <div class="pr-2.5 mr-2.5 border-r border-r-gray-300 flex items-center whitespace-nowrap">
          <ion-icon name="calendar-outline" class="text-gray-400"></ion-icon>
          <div class="ltr:ml-1.5 rtl:mr-1.5">{{ summary?.createDate | prettyDate | async }}</div>
        </div>
        <div class="flex items-center flex-auto overflow-hidden">
          <app-initials-avatar [avatarId]="summary?.user?.avatarId" [user]="{name: summary?.user?.name}" [width]="20" [textSize]="'text-xs'"></app-initials-avatar>
          <div class="ltr:ml-2 rtl:mr-2 flex w-full overflow-hidden">
            <div class="text-base text-gray-400 truncate">{{ summary?.user?.name }}</div>
          </div>
        </div>
      </div>
      <div class="title mt-5 text-2xl flex flex-col w-full px-5 pb-5">
        {{ summary?.title }}
      </div>
      <div class="mt-5 flex flex-col w-full overflow-y-auto px-5 pb-5">
        <div>{{ summary?.summary }}</div>
      </div>
    </div>
  </ion-content>

  <ion-footer>
    <ion-toolbar>
      <div class="flex justify-center items-center pb-2 pt-1">
        @if (me().id === summary.user?.id) {
          @if (!summary.shared && summary.room.mode !== RoomMode.SINGLE) {
            <div>
              <button mat-icon-button class="text-lg" (click)="shareSummary()">
                <ion-icon name="share-outline" class="text-4xl"></ion-icon>
              </button>
            </div>
            <div class="w-[1px] h-[20px] border-r border-r-gray-300 mx-6"></div>
          }
          <div>
            <button mat-icon-button class="text-lg" (click)="deleteSummary()">
              <ion-icon name="trash-outline" class="text-4xl"></ion-icon>
            </button>
          </div>
        }      </div>
    </ion-toolbar>
  </ion-footer>
</div>
